import type { ReactNode } from "react"

import type { TimezoneNote } from "./timezone-note"
import styles from "./timezone-stripe.module.css"

/**
 * Полоса часового пояса филиала.
 *
 * ПОЧЕМУ ОНА ОТДЕЛЬНАЯ И НЕ ВХОДИТ В ТРИ СЛУЖЕБНЫЕ. Служебные полосы говорят о неполадке:
 * связь пропала, оплата просрочена, в кабинете чужой человек. Эта говорит о НОРМЕ — филиал
 * живёт в другом поясе, и так и должно быть. Смешать их значит либо поднять тревогу там,
 * где её нет, либо приглушить настоящую. Поэтому у неё свой спокойный тон, своё место —
 * ПОД шапкой, а не над ней, — и свой порядок: она относится к выбранному филиалу,
 * а филиал выбирается в шапке.
 *
 * Обе цифры стоят рядом намеренно: «16:40 по времени салона · у вас сейчас 14:40».
 * Человек, которому дали только разницу в часах, считает в уме — и ошибается на час
 * дважды в год, в переход на летнее время.
 */
export function TimezoneStripe(props: { readonly note: TimezoneNote }): ReactNode {
  return (
    <div className={styles.stripe} role="status">
      {/* Пробел между частями нужен телефону: там полоса — обычный абзац, а не строка
          с зазором, и без него выходило «к вашему· 16:40». В строке ноутбука пробел
          между элементами не рисуется — зазор задаёт gap. */}
      <b className={styles.lead}>{props.note.lead}</b>{" "}
      <span className={styles.tail}>· {props.note.tail}</span>
    </div>
  )
}
